import Vue from 'vue'
import Router from 'vue-router'

// import Home from '@/page/video/growinfo'    //国际化版跟读
// import Home from '@/page/video/growvideo'   //国际化版跟读
// import Home from '@/page/video/videoEn'   //国际化版跟读


/* 纠音 V1.1.0 */

  // import Home from '@/views/En/Correct'   //国际化版跟读
  // import Home from '@/views/Correct'   //跟读
  // import Home from '@/views/En/CorrectShare'   //海报国际版
  // import Home from '@/views/CorrectShare'   //海报
  // import Home from '@/views/En/dictationShare'   // 听写海报国际版
  // import Home from '@/views/dictationShare'   //听写海报

  // import Home from '@/views/correctShare/download'   //纠音

  
  // import Home from '@/views/Info'   //纠音
  // import Home from '@/views/InfoShare'   //纠音

/* 纠音 V1.1.0 */

/* VIP start*/
// import VIPShop from './VIPshop/VIPshop'
/* VIP end */


/* 童伴成长邀请 start*/
// import Invite from './Invite_grow/index'
// import Home from '@/page/grow_invite/inviteShare'   //邀请
/* 童伴成长 end */

/* 邀请 start*/
// import Invite from './Invite/index'
// import Home from '@/page/share/inviteShare'   //邀请
// import Rule from '@/page/share/rule'   //邀请规则
/* 邀请 end */

/* 单词挑战赛 */
// import Home from '@/page/wordChallenge/index'   //单词挑战
// import Rule from '@/page/wordChallenge/list'   //单词挑战列表

// import Home from '@/page/wordChallenge/down'   //单词挑战下载页面

// import Home from '@/page/wordChallenge/activity01'   //单词挑战

// import Home from '@/page/staticget'   //达标得
// import Home from '@/page/newyear'   //新春活动

/* 单词挑战赛 */

/* 纠音 V1.2.0 */
  // import Home from '@/views/correctShare/correctShare'   //纠音分享
  // import Home from '@/views/correctShare/followShare'   //跟读分享
/* 纠音 V1.2.0 */

/* 纠音 V1.3.1 */
  // import Home from '@/views/v1.3.1/info'   //听写简介

  
  // import Home from '@/views/v1.3.1/index'   //单词挑战
  // import Rule from '@/views/v1.3.1/list'   //单词挑战列表
  // import RuleL4 from '@/views/v1.3.1/listL4'   //单词挑战列表

  // import Home from '@/views/v1.3.1/down'   //单词挑战列表
/* 纠音 V1.3.1 */

// import UserAgree from '@/views/En/UserAgree' 
// import aboutUs from '@/views/En/aboutUs'

// import Home from '@/views/sentence/U1/Fm/W1PA'   //纠音
// import Home from '@/views/sentence/download'   //纠音
// import Home from '@/page/sentence/bookall'   //纠音


/*  分享  start  */

// import Home from '@/page/share/umishowShare'   //ummishow 分享页面
// import Home from '@/page/share/dubShare'   //配音分享
// import Home from '@/page/share/bookShare'   //绘本分享

/*  分享  end  */



// import Home from '@/page/grow_down'   //童伴成长下载


/* 用户相关 start*/
  // import Privacy from '@/views/user/Privacy'
  // import Children from '@/views/user/Children'  
  import aboutUs from '@/views/cUser/aboutUs'
  import UserAgree from '@/views/cUser/UserAgree'
  // import msgDetail from '@/views/user/messageDetail'
/* 用户相关 end*/

const baseRoutes = [
  // {  path: '/Home', name: 'Home', component: Home },
	// {  path: '/Rule', name: 'Rule', component: Rule },
	// {  path: '/RuleL4', name: 'RuleL4', component: RuleL4 },

	// 用户相关
	{ path: '/UserAgree', name: 'UserAgree', component: UserAgree},
	{ path: '/aboutUs', name: 'aboutUs', component: aboutUs},
	// { path: '/msgDetail', name: 'msgDetail', component: msgDetail},
	// { path: '/Privacy', name: 'Privacy', component: Privacy},
	// { path: '/Children', name: 'Children', component: Children},

	// { path: '/Game', name: 'Game', component: Game},
	// { path: '/Game1', name: 'Game1', component: Game1},
];

// const routes = baseRoutes.concat(VIPShop);
const routes = baseRoutes;


Vue.use(Router)

export default new Router({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js